import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import Header from "../../layout/Header/Header";
import { MenuCard, MenuHeader, MenuSection } from "../../MenuCard";

const ITEMS = [
  { type: "section", label: "Cobranza" },
  { label: "Ventas", icon: "fas fa-money-bill-wave", color: "#10b981", bg: "#f0fdf4", href: "/ListadoVentas", desc: "Ventas registradas", perm: "menu_ventas" },
  { label: "Anticipos", icon: "fas fa-hand-holding-usd", color: "#3b82f6", bg: "#eff6ff", href: "/ListadoAnticipos", desc: "Anticipos de clientes", perm: "menuAnticipos" },
  { label: "Abonos", icon: "fas fa-dollar-sign", color: "#f59e0b", bg: "#fffbeb", href: "/ListadoAbonos", desc: "Abonos recibidos", perm: "abonos" },
  { label: "Abonos Agrupado", icon: "fas fa-dollar-sign", color: "#8b5cf6", bg: "#f5f3ff", href: "/ListadoAbonosAgrupado", desc: "Abonos agrupados por código", perm: "abonos" },
  { label: "Estado Cuenta", icon: "fas fa-file-invoice-dollar", color: "#0ea5e9", bg: "#f0f9ff", href: "/EstadoCuenta", desc: "Estado de cuenta por cliente", perm: "edoCtaClientes" },
  { type: "section", label: "Movimientos" },
  { label: "Devoluciones", icon: "fas fa-undo-alt", color: "#f43f5e", bg: "#fff1f2", href: "/ListadoDevolucionesAdmin", desc: "Devoluciones de clientes", perm: "menu_devolucionesAdmin" },
  { label: "Comisiones", icon: "fas fa-percentage", color: "#14b8a6", bg: "#f0fdfa", href: "/ListadoComisiones", desc: "Comisiones de vendedores", perm: "comisiones" },
  { type: "section", label: "Bancos y catálogos" },
  { label: "Bancos", icon: "fas fa-university", color: "#6366f1", bg: "#eef2ff", href: "/Bancos", desc: "Catálogo de cuentas bancarias", perm: "bancos" },
  { label: "Movimientos Bancos", icon: "fas fa-list-ol", color: "#10b981", bg: "#f0fdf4", href: "/MovimientosBancos", desc: "Movimientos de bancos", perm: "bancos" },
  { label: "Empresas", icon: "fas fa-industry", color: "#3b82f6", bg: "#eff6ff", href: "/Empresas", desc: "Catálogo de empresas", perm: "bancos" },
  { type: "section", label: "Reportes" },
  { label: "Reporte Ingresos", icon: "fas fa-dollar-sign", color: "#f59e0b", bg: "#fffbeb", href: "/ListadoAbonosGeneral", desc: "Reporte general de ingresos", perm: "abonos" },
];

function BotonesAdmin() {
  const { user } = useContext(AuthContext);
  return (
    <>
      <Header />
      <div className="card container">
        <MenuHeader icon="fas fa-hand-holding-usd" color="#6366f1" bg="#eef2ff" title="Administración" subtitle="Ingresos, bancos y estado de cuenta" />
        {user.configAdmin ? (
          <div className="row">
            {ITEMS.map((r, i) =>
              r.type === "section"
                ? <MenuSection key={i} title={r.label} />
                : <MenuCard key={i} {...r} enabled={!!user[r.perm]} />
            )}
          </div>
        ) : <p style={{ color: "#94a3b8", fontSize: "0.82rem" }}>Sin acceso.</p>}
      </div>
    </>
  );
}

export default BotonesAdmin;
